import { Controller } from "@hotwired/stimulus"
import { openModal } from "../../website/modal"

export default class extends Controller {
  connect() {
    this.element.setAttribute("aria-haspopup", "dialog")
    this.element.setAttribute("aria-expanded", "false")
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    openModal(this.element.getAttribute("aria-controls"), this.element)
  }
}
